import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/close_btn.png'


const _hoisted_1 = { class: "modal_bg" }
const _hoisted_2 = { class: "modal_wrap modal_alert" }
const _hoisted_3 = { class: "close_btn_wrap" }
const _hoisted_4 = { class: "tit align_cnt" }
const _hoisted_5 = { class: "modal_con_wrap" }
const _hoisted_6 = { class: "modal_con" }
const _hoisted_7 = { class: "btn_wrap align_right" }

import { ModalEmits, ModalProps } from "@/interface/modal";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
    title: {},
    content: {},
    no: {},
    yes: {},
    type: {},
    pageMove: {}
  },
  emits: ["close", "pageMove"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const fnEvent = (result: boolean) => {
        if (result === false) {
            emit("close", false);
        } else {
            emit("close", true);
        }
    };
    const pageMoving = () => {
        emit("pageMove");
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (fnEvent(false)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "img_con",
            alt: "닫기버튼"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.content), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (__props.no)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn_no",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (fnEvent(false)))
            }, _toDisplayString(__props.no), 1))
          : _createCommentVNode("", true),
        (__props.yes)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn_yes",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fnEvent(true)))
            }, _toDisplayString(__props.yes), 1))
          : _createCommentVNode("", true),
        (__props.pageMove)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn_move_page",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (pageMoving()))
            }, _toDisplayString(__props.pageMove), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})